import { useObserver } from "mobx-react";
import { useRef, useState } from "react";
import { AiOutlineClose, AiOutlinePlus } from "react-icons/ai";
import { PrimaryButton } from "../reusble_components/buttons/primaryButton";
import { useStores } from "../../store"; // Make sure to import your store
import { set, toJS } from "mobx";
import { Tooltip } from "react-tooltip";
import { FiPlusCircle } from "react-icons/fi";

export default function Skills(props) {
  const { RecuiterStore } = useStores(); // Assuming your store has a requiredSkillsStore
  const skillinputRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  const setaddedSkills = (skill) => {
    if (skill === "") {
      alert("Enter skill");
      return;
    } else {
      props.setaddedSkills(skill);
      if (props?.lab === "Suggested Technologies/Tools") {
        
        return;
      }
      const requiredSkills =
        RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills;

      if (!requiredSkills.includes(skill)) {
        RecuiterStore.setBasicJobDetails("requiredSkills", [
          ...requiredSkills,
          skill,
        ]);
        RecuiterStore.setSkillsField(false);
      } else {
        alert("This skill is already in the list");
      }
    }
  };

  const removeSkills = (index) => {
    if (props?.lab === "Suggested Technologies/Tools") {
      props.removeSkills(index);
      return;
    }
    const updatedSkills =
      RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills.filter(
        (_, i) => i !== index
      );
    props.removeSkills(index);
    RecuiterStore.setBasicJobDetails("requiredSkills", updatedSkills);
  };

  return useObserver(() => (
    <>
      <div className="flex flex-col relative gap-1 text-lg  md:mt-2 lg:mt-8 mt-2 ">
        <label className="font-sans text-base ml-3 text-[#6D6B6B] tc5:mt-2 tc6:mt-2 tc7:mt-2 tc8:mt-2">
          {props.lab || "Skills Required"}{" "}
          {RecuiterStore.skillsField ? (
            <p className="text-sm text-red-500">
              {" "}
              [ Please select at Least 1 skill ]
            </p>
          ) : null}{" "}
        </label>

        {props.value || props?.lab === "Suggested Technologies/Tools" ? (
          <div
            className={`w-full border flex items-center flex-wrap  ${
              RecuiterStore.skillsField ? "border-red-500" : "border-[#c9c9c9]"
            } rounded-lg px-4 gap-4 
        ${props.value?.length > 0 ? "py-4" : "py-6"}
         `}
          >
            {props.value?.map((skill, index) => (
              <div
                key={index}
                className="flex items-center   w-fit justify-between  gap-2 bg-primary text-white rounded-full px-4 h-9"
              >
                <p>{skill}</p>
                <button type="button" onClick={() => removeSkills(index)}>
                  <AiOutlineClose />
                </button>
              </div>
            ))}
          </div>
        ) : (
          <div
            className={`w-full border flex items-center relative flex-wrap  ${
              RecuiterStore.skillsField ? "border-red-500" : "border-[#c9c9c9]"
            } rounded-lg px-4 gap-4
          ${
            RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills.length >
            0
              ? "py-4"
              : "py-6"
          }
           `}
          >
            {RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills.map(
              (skill, index) => (
                <div
                  key={index}
                  className="flex items-center   w-fit justify-between  gap-2 bg-black text-white rounded-full px-4 h-9"
                >
                  <p>{skill}</p>
                  <button type="button" onClick={() => removeSkills(index)}>
                    <AiOutlineClose />
                  </button>
                </div>
              )
            )}
          </div>
        )}
        <div className="flex flex-wrap w-full items-center px-4 my-4 md:gap-4 lg:gap-4 gap-2">
          {props.Skills.map((skill) => (
            <button
              type="button"
              key={skill}
              onClick={() => setaddedSkills(skill)}
              className="mb:px-4 lg:px-4 px-3 md:text-base lg:text-base text-sm flex items-center  gap-1 focus:outline-none  text-[#6d6d6d] bg-[#D9D9D9] rounded-full h-9        "
            >
              {skill} <AiOutlinePlus />
            </button>
          ))}
          <PrimaryButton
            icon={<AiOutlinePlus />}
            buttonName={"Add Skill"}
            onClick={() => {
              setShowPopup(true);
              setTimeout(() => {
                skillinputRef.current.focus();
              }, 100);
            }}
            width="w-fit"
          />
        </div>
      </div>
      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center backdrop-blur-sm justify-center gap-8 bg-gray-500 bg-opacity-20 z-50">
          <div className=" flex bg-white flex-col md:w-[30vw] lg:w-[30vw] w-[90vw] p-5  rounded-xl relative flex items-center gap-4">
            <div className=" border-[#ff6800] border-2 p-[2px] absolute top-3 right-3 rounded-full">
              <AiOutlineClose
                onClick={() => setShowPopup(false)}
                className=" w-[8px] h-[8px] cursor-pointer text-[#ff6800]"
              />
            </div>
            <h1 className="text-xl mr-auto mt-3 ml-8 lg:ml-4 md:ml-4">
              Add skills
            </h1>

            <input
              type="text"
              placeholder="Enter skill"
              id="EnterSkill"
              name="EnterSkill"
              className="p-2 focus:outline-none rounded-xl text-xl md:w-[95%] lg:w-[95%] w-[80%] bg-gray-200 "
              ref={skillinputRef}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  const newSkill = skillinputRef.current.value;
                  setaddedSkills(newSkill);
                  // setShowPopup(false);
                }
              }}
            />
            <FiPlusCircle
              className="md:ml-[80%] lg:ml-[80%] cursor-pointer ml-[60%] w-6 h-6 text-primary  -mt-12"
              onClick={() => {
                const newSkill = skillinputRef.current.value;
                setaddedSkills(newSkill);
                skillinputRef.current.value = null;
              }}
            />
           {!props.lab && <div className="flex flex-wrap gap-2 md:w-[95%] lg:w-[95%] w-[80%] mt-2 items-center justify-start">
              {RecuiterStore.jobPostDetails.basicJobDetails.requiredSkills.map(
                (skill, index) => (
                  <div
                    key={index}
                    className="flex items-center  max-w-32 w-fit justify-between  gap-2 bg-black text-white rounded-full px-4 h-9"
                  >
                    <p>{skill}</p>
                    <button type="button" onClick={() => removeSkills(index)}>
                      <AiOutlineClose />
                    </button>
                  </div>
                )
              )}
            </div>}

            {/* <div className="flex py-2 ml-32  md:ml-72 lg:ml-72 items-center gap-4">
              <PrimaryButton
                buttonName={"Add"}
                padding={8}
                onClick={() => {
                  setShowPopup(false);
                }}
              />
            </div> */}
          </div>
        </div>
      )}
    </>
  ));
}
